// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 115 ? "viewUtilPlugins-legacy" : chunkId) + ".js";
};